module.exports = __webpack_public_path__ + "media/images/dialpad-icon-80ab5e10aee84e01fb2c0b0a3438829685c5c62dce746e4360876115f3de9c6f.svg";